<template>
  <div class="row items-center">
    <div class="col-5 q-mr-auto">
      <q-field class="form-hint no-padding" :model-value="!isSchedulingInvalid" :rules="[isIncomplete]" />
    </div>
    <div class="col">
      <q-tabs
        class="quota-tabs items-center"
        active-color="primary"
        indicator-color="primary"
        :model-value="modelValue"
        @update:model-value="$emit(EQuotaTabsEmitName.UpdateModelValue, $event)"
      >
        <q-tab :name="EQuotaTab.Quota" aid="quota-tab">
          <div class="row items-center">
            <div class="q-tab__label q-mr-sm">Quota</div>
            <q-icon v-if="isQuotaInvalid" name="fa-regular fa-circle-exclamation" color="red" />
          </div>
        </q-tab>
        <q-tab :name="EQuotaTab.Scheduling" aid="scheduling-tab">
          <div class="row items-center q-mr-md">
            <div class="q-tab__label q-mr-sm">Scheduling preferences</div>
            <q-icon
              v-if="!isSchedulingInvalid"
              aid="shceduling-invalid-tab-icon"
              name="fa-regular fa-circle-exclamation"
              color="red"
            />
          </div>
        </q-tab>
      </q-tabs>
    </div>
  </div>
  <q-separator />
</template>
<script lang="ts">
import { EQuotaTab } from "@/models/org-unit.model";

export enum EQuotaTabsEmitName {
  UpdateModelValue = "update:model-value",
}
import { defineComponent, type PropType } from "vue";
import { errorMessages } from "@/common/error-message.constant";
export default defineComponent({
  name: "quota-tabs",
  emits: {
    [EQuotaTabsEmitName.UpdateModelValue]: (value: string) => value,
  },
  props: {
    modelValue: {
      type: String as PropType<EQuotaTab>,
      default: EQuotaTab.Quota,
    },
    isQuotaInvalid: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    isSchedulingInvalid: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
  computed: {
    EQuotaTab(): typeof EQuotaTab {
      return EQuotaTab;
    },
    EQuotaTabsEmitName(): typeof EQuotaTabsEmitName {
      return EQuotaTabsEmitName;
    },
  },
  methods: {
    isIncomplete(val: boolean): boolean | string {
      return !val ? true : errorMessages.QUOTA_MANAGEMENT_PREFERENCE_ISSUE;
    },
  },
});
</script>
